import { pick, toNumber } from "@components/health/clients/health-clients-utils";

export const SPR_TEXT_TABS = [
  { key: "0", vid: 0, label: "Диагнозы" },
  { key: "1", vid: 1, label: "Шаблоны истории болезни" },
  { key: "2", vid: 2, label: "Основание платежа" },
  { key: "3", vid: 3, label: "Комментарии" }
];

/** Как Delphi GetUserLaw: отсутствующий бит = разрешено. */
export const getLawFlag = (law, index) => {
  if (!law || law.length <= index) return 1;
  const n = Number(law[index]);
  return Number.isFinite(n) ? n : 1;
};

export const normalizeSprText = (row) => ({
  vid: toNumber(pick(row, "vid", "Vid")) ?? 0,
  idText: toNumber(pick(row, "idText", "IdText")),
  idUpper: toNumber(pick(row, "idUpper", "IdUpper")) ?? 0,
  name: pick(row, "name", "Name") ?? "",
  kod: pick(row, "kod", "Kod") ?? ""
});

export const SPR_TEXT_FILE_FORMAT = "plan-spr-text";

export const buildSprTextExport = (vid, rows) => ({
  format: SPR_TEXT_FILE_FORMAT,
  version: 1,
  vid,
  label: SPR_TEXT_TABS.find((t) => t.vid === vid)?.label || "",
  exportedAt: new Date().toISOString(),
  items: (rows || []).map((r) => ({
    idText: r.idText,
    idUpper: r.idUpper || 0,
    name: r.name || "",
    kod: r.kod || ""
  }))
});

/** Returns { vid, items } or throws Error with a Russian message. */
export const parseSprTextImport = (text) => {
  let parsed;
  try {
    parsed = JSON.parse(text);
  } catch {
    throw new Error("Файл не является корректным JSON");
  }
  if (!parsed || parsed.format !== SPR_TEXT_FILE_FORMAT || !Array.isArray(parsed.items)) {
    throw new Error("Файл не является выгрузкой шаблонов");
  }
  const vid = toNumber(parsed.vid);
  const items = parsed.items
    .map((row) => ({
      idText: toNumber(pick(row, "idText", "IdText")),
      idUpper: toNumber(pick(row, "idUpper", "IdUpper")) ?? 0,
      name: pick(row, "name", "Name") ?? "",
      kod: pick(row, "kod", "Kod") ?? ""
    }))
    .filter((r) => r.idText != null);
  return { vid, items };
};

/** Плоский список → дерево для Ant Design Table (children). */
export const buildTextTree = (rows) => {
  const list = (rows || []).filter((r) => r.idText != null);
  const byId = new Map();
  list.forEach((r) => {
    byId.set(r.idText, { ...r, children: [] });
  });

  const roots = [];
  byId.forEach((node) => {
    const parentId = node.idUpper || 0;
    if (parentId > 0 && byId.has(parentId)) {
      byId.get(parentId).children.push(node);
    } else {
      roots.push(node);
    }
  });

  const prune = (nodes) =>
    nodes.map((n) => {
      const children = n.children?.length ? prune(n.children) : undefined;
      const next = { ...n };
      if (children?.length) next.children = children;
      else delete next.children;
      return next;
    });

  return prune(roots);
};
